import { render, staticRenderFns } from "./wait.vue?vue&type=template&id=237d2a12&scoped=true&"
import script from "./wait.vue?vue&type=script&lang=js&"
export * from "./wait.vue?vue&type=script&lang=js&"
import style0 from "./wait.vue?vue&type=style&index=0&id=237d2a12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237d2a12",
  null
  
)

export default component.exports